// extracted by mini-css-extract-plugin
export default {"goesOnSaleContainer":"p7jI9"};